import "../Styles/Business_set.css";
import { Link } from "react-router-dom";
import { clearLoginData, getData, saveData } from "../utils/store-data";
import ReactDatePicker from "react-datepicker";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  GOOGLE_USER,
  LOGIN_BY,
  PHNO,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";
import {
  check_bussiness_name,
  check_phone_no,
  create_agent,
  create_client,
  get_all_countries,
  get_castes,
  get_cities,
  get_client_relations,
  get_communities,
  get_country_list,
  get_country_states,
  get_habits,
  get_hobbies,
  get_language,
  get_level1_caste,
  get_marital_status,
  get_physical_build,
  get_qualification,
  get_relations,
  get_religios,
  get_skin_tone,
  get_states,
  update_profile_photo,
  get_level2_caste,
  get_level3_caste,
  create_profile,
  update_profile_video,
  get_profile_byid,
  update_client_photo,
  update_profile_document,
} from "../api/serverWrapper";
import { useEffect, useState, useRef } from "react";
import Agent from "../components/Agent";
import UserInfo from "../components/UserInfo";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import UserSystemRole from "../components/UserSystemRole";
import { customStyles, customStylesbusiness } from "../utils/commonFunctions";
import Profile from "../components/Profile";
import { subYears } from "date-fns";
import CreateProfilePopup from "./CreateProfilePopup";
import { useMasterData } from "../context/MasterDataContext";
import {
  loginByEmail,
  loginByGoogle,
  loginByPhoneNo,
} from "../utils/Constants";
import AddFamilyMemeberForClient from "./AddFamilyMemeberForClient";
import AddFamilyWealthForClient from "./AddFamilyWealthForClient";
import EducationWorkForm from "./EducationWorkForm";
import PhysicalAttributesForm from "./PhysicalAttributesForm";
import LifestyleAndInterests from "./LifestyleAndInterests";
import VideoAndDocumentsUploader from "./VideoAndDocumentsUploader";
import PhotographUploader from "./PhotographUploader";
import ClientPreferences from "./ClientPreferences";
import ClientSetupStepper from "../components/ClientSetup/ClientSetupStepper";
import ClientSetupHeader from "../components/ClientSetup/ClientSetupHeader";
import { useLocation } from "react-router-dom";
import ClientPayment from "../components/ClientSetup/ClientPayment";

function Client_set_up() {
  const {
    religionMasterData,
    countryMasterData,
    allCasteMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    communityMasterData,
    languageMasterData,
    relationsMasterData,
    clientRelationsMasterData,
    communityDocsMasterData,
    allCountyMasterData,
    selectedCountryCode,
  } = useMasterData();

  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();

  // if (loading || !masterData) return <Loader />;
  const navigate = useNavigate();
  let [userData, setUserData] = useState(new UserInfo());
  const [showProfilePopup, setShowProfilePopup] = useState(true);

  const profileType = location?.state?.profileType;

  const [ClientFirstName, setClientFirstName] = useState("");
  const [ClientLastName, setClientLastName] = useState("");
  const [selectedGender, setSelectedGender] = useState(null);

  const [description, setDescription] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");

  const [open, setOpen] = useState(false);
  const datePickerRef = useRef();

  const handleIconClick = (e) => {
    e.stopPropagation(); // prevent closing
    setOpen(true); // manually open the picker
  };

  // Image Options BEGIN
  const defaultImage = require("../assests/images/profile.png");
  const [imageSource, setImageSource] = useState(defaultImage);
  let [selectedImage, setSelectedImage] = useState("");
  const [isDialogVisible, setDialogVisible] = useState(false);
  let [UserId, setUserId] = useState(null);

  const [btnLoading, setBtnLoading] = useState(false);

  let [profileData, setProfileData] = useState(new Profile());

  const [accessOnRequest, setAccessOnRequest] = useState(false);
  const [mainIndex, setMainIndex] = useState(0);

  const [countryCode, setCountryCode] = useState(""); // e.g. "IN"
  const [states, setStates] = useState([]);
  // const [selectedState, setSelectedState] = useState(null);

  const [cities, setCities] = useState([]);
  // const [selectedCity, setSelectedCity] = useState(null);
  const [countries, setCountries] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [phno, setPhno] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [collageName, setCollageName] = useState("");
  const [jobRole, setJobRole] = useState("");

  let [ClientRelationId, setClientRelationId] = useState(null);

  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [desc, setDesc] = useState("");
  const [Salary, setSalary] = useState("");
  const [carrerGoals, setcarrerGoals] = useState("");
  const [salaryCurrency, setSalaryCurrency] = useState("");
  const [familyDetails, setFamilyDetails] = useState([
    { RelationshipId: 1, FamilyMemberName: "", Occupation: "", RoleDesc: "" }, // Father
    { RelationshipId: 2, FamilyMemberName: "", Occupation: "", RoleDesc: "" }, // Mother
  ]);

  const [familyWealth, setFamilyWealth] = useState([]);

  const [communitieDocs, setCommuniteDocs] = useState(
    communityDocsMasterData || [],
  );

  const [docFile, setDocFile] = useState(null);
  const [docName, setDocName] = useState("");

  const [languages, setLanguage] = useState(languageMasterData);
  const [selectedLanguage, setSelectedLanguage] = useState([]);

  const [selectedRelation, setSelectedRelation] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");

  let self = 1;
  let parent = 2;

  const [religion, setReligion] = useState(religionMasterData);
  const [relations, setRelations] = useState([]);
  const [relationsForClient, setRelationsForClients] = useState([]);
  // const [selectedRelationFrClient, setSelectedRelationFrClient] =
  //   useState(self);
  const [selectedRelationFrClient, setSelectedRelationFrClient] = useState(
    profileType === "parent" ? parent : self,
  );
  const [countryList, setCountryList] = useState(countryMasterData);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [caste, setCaste] = useState([]);
  const [level1Caste, setLevel1Caste] = useState([]);
  const [level2Caste, setLevel2Caste] = useState([]);
  const [level3Caste, setLevel3Caste] = useState([]);
  const [communityList, setCommunity] = useState(communityMasterData);
  const [maritalStatus, setMaritalStatus] = useState(maritalStatusMasterData);
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData);
  const [physicalbuildList, setPhysicalBuildList] = useState(buildMasterData);
  const [habitList, setHabitList] = useState(habitsMasterData);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData);
  const [qualifications, setQualifications] = useState(qualificationMasterData);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedResidence, setSelectedResidence] = useState("");
  const [selectedCitizenship, setSelectedCitizenship] = useState("");
  const [seletedEthinicity, setSelectedEthinicity] = useState("");
  const [postalcode, setPostalCode] = useState("");

  let [selectedReligion, setSelectedReligion] = useState("");

  let [selectedCaste, setSelectedCaste] = useState("");
  const [selectedCommunities, setSelectedCommunities] = useState("");
  const [selectedLevel2Caste, setSelectedLevel2Caste] = useState("");
  const [selectedLevel3Caste, setSelectedLevel3Caste] = useState("");
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState("");
  const [selectedSkinTone, setSelectedSkinTone] = useState(null);
  const [selectedBuild, setSelectedBuild] = useState(null);
  const [selectedHabit, setSelectedHabit] = useState([]);
  const [selectedHobbies, setSelectedHobbie] = useState([]);

  let [selectedDate, setSelectedDate] = useState("");
  const [limitSameReligion, setLimitSameReligion] = useState(false);
  const [limitSameCaste, setLimitSameCaste] = useState(false);
  const [limitSameSubCaste, setLimitSameSubCaste] = useState(false);
  const [limitSameSubCommunity, setLimitSameSubCommunity] = useState(false);
  const [limitLanguage, setLimitLanguage] = useState(false);
  let [Email, setEmail] = useState("");
  let [loginby, setLoginby] = useState(loginByPhoneNo);

  let [profileImages, setProfileImages] = useState([]);
  const [videoFile, setVideoFile] = useState(null);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      // ✅ STEP 1: GET LOGIN METHOD
      const loginMethod = Number(await getData(LOGIN_BY));

      // ==============================
      // ✅ EMAIL LOGIN
      // ==============================
      if (loginMethod === loginByEmail) {
        const mail = await getData(USER_EMAIL);

        if (mail) {
          setEmail(mail);
          setLoginby(loginByEmail);
        }
      }

      // ==============================
      // ✅ GOOGLE LOGIN
      // ==============================
      const googleUserStr = await getData(GOOGLE_USER);

      console.log("googleUserStr");

      if (googleUserStr) {
        const googleUser = JSON.parse(googleUserStr);

        if (googleUser) {
          setEmail(googleUser.email || "");
          setClientFirstName(googleUser.name?.split(" ")[0] || "");
          setClientLastName(googleUser.name?.split(" ")[1] || "");
          setImageSource(googleUser.picture || defaultImage);

          setLoginby(loginByGoogle);
        }
      }

      // ==============================
      // ✅ PHONE LOGIN
      // ==============================
      if (loginMethod === loginByPhoneNo) {
        const phno = await getData(PHNO);

        console.log("phno", phno);

        if (phno) {
          setPhoneNumber(phno);
          setLoginby(loginByPhoneNo);
        }
      }

      // ==============================
      // ✅ LOAD MASTER DATA
      // ==============================
      await fetchCountries();

      let clientRelationsData = await get_client_relations();

      let coutrylist = await get_country_list();

      // let filterrelations = relationsMasterData.filter((item) =>
      //   [1, 2, 7, 8, 10, 11].includes(item.RelationshipId),
      // );

      let filterrelations = relationsMasterData;

      setRelations(filterrelations);
      setRelationsForClients(clientRelationsData.data);
    } catch (error) {
      console.log("loadInitialData error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCountries = async () => {
    try {
      const res = await get_all_countries(); // replace with your endpoint
      const data = res;

      if (data.success) {
        const formatted = data.data.map((c) => {
          const code = c.phonecode.startsWith("+")
            ? c.phonecode
            : `+${c.phonecode}`;
          return {
            value: c.isoCode,
            label: `${c.name} (${code})`,
            name: c.name,
            phoneCode: c.phonecode,
          };
        });
        console.log("formatted get_all_countries", formatted);
        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };

  useEffect(() => {
    console.log("Selectd countryCode", countryCode);

    if (countryCode) {
      (async () => {
        try {
          console.log("Selectd inside countryCode", countryCode);
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            console.log("formattedStates ", formattedStates);

            setStates(formattedStates);
            setSelectedState(null); // reset state
            setCities([]); // reset cities
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  useEffect(() => {
    if (!countryCode || !allCountyMasterData?.length) return;

    const selectedCountry = allCountyMasterData.find(
      (c) => c.isoCode === countryCode,
    );

    if (selectedCountry?.currency) {
      setSalaryCurrency(selectedCountry.currency);
    }
  }, [countryCode, allCountyMasterData]);

  // Prefill countryCode from selectedCountryCode (set during Signup)
  useEffect(() => {
    if (countries.length > 0 && selectedCountryCode && !countryCode) {
      const matchedCountry = countries.find(
        (c) => String(c.phoneCode) === String(selectedCountryCode),
      );

      if (matchedCountry) {
        setCountryCode(matchedCountry.value);
      }
    }
  }, [countries, selectedCountryCode]);

  // 2️⃣ When state changes, fetch cities
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState.value);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
            }));
            setCities(formattedCities);
            setSelectedCity(null);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const handleReligionDataFromChild = async (e) => {
    let id = Number(e.target.value);
    selectedReligion = id;
    setSelectedReligion(selectedReligion);
    await getLevel1Castes(id);
    await getlevl2Caste(id, null);
  };

  const getLevel1Castes = async (id) => {
    let level1castelist = await get_level1_caste(id);
    setLevel1Caste(level1castelist.data);
  };

  const getlevl2Caste = async (selectedReligion, id) => {
    let data = await get_level2_caste(selectedReligion, id);
    console.log("get level2 caste", data);
    setLevel2Caste(data.data);
  };

  const handlelevle2Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel2Caste(id);
    if (id) {
      getLevel3Caste(id);
    }
  };

  const getLevel3Caste = async (id) => {
    console.log(selectedCaste);

    let resp = await get_level3_caste(selectedCaste, id);
    setLevel3Caste(resp.data);
  };

  const handleLevel3Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel3Caste(id);
  };

  const [addresDet, setAddressDet] = useState("");

  const handelAddreesDet = (e) => {
    let text = e.target.value;
    setAddressDet(text);
    profileData.address.AddressDetails = text;
  };

  const handleResidence = (e) => {
    let val = Number(e.target.value);
    setSelectedResidence(val);
  };

  const handleCitizenship = (e) => {
    let val = Number(e.target.value);
    setSelectedCitizenship(val);
  };

  const handleEthinicity = (e) => {
    let val = Number(e.target.value);
    setSelectedEthinicity(val);
  };

  const handlePostalcode = (e) => {
    let val = e.target.value;
    setPostalCode(val);
  };

  const renderRelations = () => {
    return maritalStatus.map((item, index) => (
      <option key={index} value={item.MarriageStatusId}>
        {item.MarriageStatus}
      </option>
    ));
  };

  const handleMaritaStatusDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedMaritalStatus(id);
  };

  const handleCommunitiesDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedCommunities(id);
  };
  const renderReligion = () => {
    return religion.map((item, index) => (
      <option key={index} value={item.ReligionId}>
        {item.ReligionName}
      </option>
    ));
  };

  const renderRelationForClient = () => {
    return relations.map((item, index) => (
      <option key={index} value={item.RelationshipId}>
        {item.RelationshipName}
      </option>
    ));
  };

  const handleRelationshipId = (e) => {
    let val = e.target.value;
    ClientRelationId = Number(val);
    setClientRelationId(ClientRelationId);
  };

  const renderLevel2Caste = () => {
    return level2Caste?.map((item, index) => (
      <option key={index} value={item.CasteL2Id}>
        {item.CasteName}
      </option>
    ));
  };
  const renderLevel3Caste = () => {
    return level3Caste?.map((item, index) => (
      <option key={index} value={item.CasteL3Id}>
        {item.CasteName}
      </option>
    ));
  };
  const renderLang = () => {
    return languages.map((item, index) => (
      <option key={index} value={item.LangId}>
        {item.LangDesc}
      </option>
    ));
  };

  const handleSelect = (e) => {
    const selectedId = Number(e.target.value);
    const lang = languages.find((l) => l.LangId === selectedId);
    if (!lang) return;

    setSelectedLanguage((prev) =>
      prev.some((c) => c.LangId === lang.LangId) ? prev : [...prev, lang],
    );
  };

  const removeLanguage = (langToRemove) => {
    setSelectedLanguage((prev) =>
      prev.filter((c) => c.LangId !== langToRemove.LangId),
    );
  };

  const showToast = (message) => {
    const toast = document.getElementById("toast-message");
    if (!toast) return;

    toast.innerText = message;
    toast.style.display = "block";

    // Force reflow to restart animation
    void toast.offsetWidth;

    toast.style.animation = "fadeInOut 3s ease-in-out";

    // Hide again after animation
    setTimeout(() => {
      toast.style.display = "none";
    }, 3000);
  };

  const checkPhoneNumber = async (phno) => {
    let resp = await check_phone_no(phno);
    console.log(resp);
    return resp.success;
  };

  const CreateClient = async () => {
    if (btnLoading) {
      return;
    }
    setBtnLoading(true);
    try {
      userData.PhoneNumber = PhoneNumber;
      userData.FirstName = ClientFirstName;
      userData.LastName = ClientLastName;

      const userId = await getData(USER_ID);
      userData.UserId = userId ? Number(userId) : -1;
      userData.SystemRole = UserSystemRole.CLIENT.id;

      if (selectedCountryCode) {
        userData.CountyCode = selectedCountryCode;
      }
      userData.Gender = selectedGender;
      userData.EMail = Email;
      userData.LoginBy = loginby;

      // Cleanup user data
      Object.keys(userData).forEach((key) => {
        if (!userData[key]) {
          delete userData[key];
        }
      });

      let clientData = {
        userInfo: userData,
        ClientDescreption:
          selectedRelationFrClient === parent ? description : desc,
      };

      if (selectedRelationFrClient === parent) {
        clientData.ParentId = ClientRelationId;
      }

      if (!(await ValidateProfile())) return;
      if (selectedRelationFrClient === self) {
        if (!validateAdressAndSalary()) return;
      }

      // return

      const resp = await create_client(clientData);
      console.log(resp);

      if (resp.code === 200) {
        if (selectedImage && selectedRelationFrClient === parent) {
          await doUpdateProfileImage(resp.data.client.UserId, selectedImage);
        }

        if (selectedRelationFrClient === self) {
          await CreateProfile(resp.data.client.UserId);
        } else {
          await saveData(USER_ID, resp.data.client.UserId);
          await saveData(AGENT_LOGIN, false);
          await saveData(CLIENT_LOGIN, true);
          await saveData(PROFILE_LOGIN, false);
          setCurrentStep(4);
        }
      } else {
        alert(`${resp.message}`);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong while creating agent.");
    } finally {
      setBtnLoading(false);
    }
  };

  const ValidateProfile = async () => {
    if (selectedRelationFrClient === parent) {
      if (!ClientRelationId) {
        showToast("Select a Creating Profile As a Profile ");
        setBtnLoading(false);
        return false;
      }

      if (!selectedImage) {
        showToast("Please upload your  profile photo.");
        setBtnLoading(false);
        return false;
      }
    }

    if (!selectedGender) {
      showToast("Please Select Gender  ");
      setBtnLoading(false);
      return false;
    }

    if (!selectedRelationFrClient) {
      showToast("Select a Relation to Create Profile");
      setBtnLoading(false);
      return false;
    }

    if (!ClientFirstName) {
      showToast("Enter First Name");
      setBtnLoading(false);
      return false;
    }

    if (!ClientLastName) {
      showToast("Enter Last Name");
      setBtnLoading(false);
      return false;
    }

    if (!countryCode) {
      showToast("Select Country");
      setBtnLoading(false);
      return false;
    }
    if (!selectedState) {
      showToast("Select State");
      setBtnLoading(false);
      return false;
    }
    if (!selectedCity) {
      showToast("Select City");
      setBtnLoading(false);
      return false;
    }

    if (!selectedGender) {
      showToast("Choose Gender");
      setBtnLoading(false);
      return false;
    }

    if (loginby === loginByPhoneNo) {
      if (!PhoneNumber) {
        showToast("Phone number is missing.");
        setBtnLoading(false);
        return false;
      }
    }

    if (loginby === loginByGoogle || loginby === loginByEmail) {
      if (!Email) {
        showToast("Email is missing.");
        setBtnLoading(false);
        return false;
      }

      if (PhoneNumber) {
        const result = await checkPhoneNumber(PhoneNumber);
        if (!result) {
          showToast("User with this phone number already exists");
          setBtnLoading(false);
          return false;
        }
      }
    }

    if (!description && selectedRelationFrClient === parent) {
      showToast("Enter Client Description");
      setBtnLoading(false);
      return false;
    }

    if (selectedRelationFrClient !== parent) {
      if (!selectedMaritalStatus) {
        showToast("Choose Relationship History");
        setBtnLoading(false);
        return false;
      }

      if (!selectedReligion) {
        showToast("Select Religion ");
        setBtnLoading(false);
        return false;
      }
      // if (!selectedCaste) {
      //   showToast("Select Caste");
      //   return false;
      // }
      if (!selectedLevel2Caste) {
        showToast("Select Sub-Caste");
        setBtnLoading(false);
        return false;
      }
      if (!selectedLevel3Caste) {
        showToast("Select Sub-communitie");
        setBtnLoading(false);
        return false;
      }

      if (selectedLanguage.length <= 0) {
        showToast("Choose Language");
        setBtnLoading(false);
        return false;
      }

      if (profileImages.length <= 0) {
        showToast("Please upload your  profile photo.");
        setBtnLoading(false);
        return false;
      }
    }
    if (loginby === loginByPhoneNo) {
      const result = await checkPhoneNumber(PhoneNumber);
      if (!result) {
        showToast("User with this phone number already exists");
        setBtnLoading(false);
        return false;
      }
    }

    return true;
  };

  const validateAdressAndSalary = () => {
    if (!Salary) {
      showToast("Enter Salary Details");
      setBtnLoading(false);
      return false;
    }

    if (!addresDet) {
      showToast("Enter Address Details");
      setBtnLoading(false);
      return false;
    }

    return true;
  };

  const handleQualificationDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedQualification(id);
  };

  const handelDataFromSkinToneModal = (e) => {
    let id = Number(e.target.value);
    setSelectedSkinTone(id);
  };

  const handelDataFromBuildModal = (e) => {
    let id = Number(e.target.value);
    setSelectedBuild(id);
  };

  const CreateProfile = async (userid) => {
    if (btnLoading) {
      return;
    }

    setBtnLoading(true);
    if (selectedCountryCode) {
      userData.CountyCode = selectedCountryCode;
    }
    userData.UserId = userid;
    userData.PhoneNumber = PhoneNumber;
    userData.FirstName = ClientFirstName;
    userData.LastName = ClientLastName;
    userData.FatherName = middleName;
    userData.DOB = selectedDate;
    userData.UserLanguage = selectedLanguage.map((lang) => lang.LangId);
    userData.SystemRole = UserSystemRole.CLIENT.id;
    profileData.ProfileDescription = desc;
    profileData.RelationId = selectedRelation;
    profileData.MarriageStatusId = selectedMaritalStatus;
    profileData.ReligionId = selectedReligion;
    profileData.CasteId = selectedCaste;
    profileData.CommunitiesId = selectedCommunities;
    profileData.CasteLevel2Id = selectedLevel2Caste;
    profileData.CasteLevel3Id = selectedLevel3Caste;

    profileData.Salary = Salary.toString();
    profileData.SalaryCurrency = salaryCurrency;
    profileData.Height = height;
    profileData.Weight = weight;
    profileData.QualificationId = selectedQualification;
    profileData.JobRole = jobRole;
    profileData.CollageName = collageName;
    profileData.BuildId = selectedBuild;
    profileData.SkinToneId = selectedSkinTone;
    profileData.ProfileHabits = selectedHabit;
    profileData.ProfileHobbies = selectedHobbies;

    profileData.familyDetails = familyDetails;
    profileData.familyWealth = familyWealth;
    profileData.CarrerGoals = carrerGoals;
    profileData.familyDetails = familyDetails;
    profileData.familyWealth = familyWealth;
    profileData.address.CountryId = countryCode;
    profileData.address.StateId = selectedState.value;
    profileData.address.CityId = selectedCity.value;
    profileData.ClientRelationId = selectedRelationFrClient;
    profileData.ClientId = userid;

    profileData.LimitSameReligion = limitSameReligion;
    profileData.LimitSameCaste = limitSameCaste;
    profileData.LimitSameSubCaste = limitSameSubCaste;
    profileData.LimitSameSubCommunity = limitSameSubCommunity;
    profileData.LimitLanguage = limitLanguage;

    if (selectedResidence) {
      profileData.address.ResidenceId = selectedResidence;
    } else {
      delete profileData.address.ResidenceId;
    }

    if (selectedCitizenship) {
      profileData.address.CitizenshipId = selectedCitizenship;
    } else {
      delete profileData.address.CitizenshipId;
    }

    if (seletedEthinicity) {
      profileData.address.Ethinicity = seletedEthinicity;
    } else {
      delete profileData.address.Ethinicity;
    }

    if (postalcode) {
      profileData.address.PostalCode = postalcode;
    } else {
      delete profileData.address.PostalCode;
    }

    // Remove empty values
    Object.keys(userData).forEach((key) => {
      if (!userData[key]) {
        delete userData[key];
      }
    });

    Object.keys(profileData).forEach((key) => {
      if (!profileData[key]) {
        delete profileData[key];
      }
    });

    setUserData(userData);
    console.log("userData", userData);
    console.log(profileData);
    profileData.userInfo = userData;
    profileData.IsPhotoVisible = accessOnRequest;
    setProfileData(profileData);

    console.log("profileData", profileData);

    // return;

    try {
      let resp = await create_profile(profileData);
      console.log(resp);

      if (resp.code === 200) {
        await uploadPhotos(resp.data.User.UserId);
        await getProfileByID(resp.data.ProfileId);

        await clearLoginData();
        await saveData(USER_ID, resp.data.User.UserId);
        await saveData(AGENT_LOGIN, false);
        await saveData(CLIENT_LOGIN, false);
        await saveData(PROFILE_LOGIN, true);
        await saveData(CLIENT_PROFILE_CODE, resp.data.ClientCode);
        setCurrentStep(3);
        // navigate("/dashboard");
      } else {
        alert("Profile not Created");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  let [UserDataMatchPrep, setUserDataMatchPrep] = useState(null);

  async function getProfileByID(id) {
    let resp = await get_profile_byid(id);
    console.log("client main ", resp.data[0]);
    UserDataMatchPrep = resp?.data[0];
    setUserDataMatchPrep(UserDataMatchPrep);
  }

  const uploadPhotos = async (id) => {
    try {
      // ✅ PURE FILES
      const imageFiles = profileImages
        .map((item) => item.file || item)
        .filter((item) => item instanceof File);

      // ✅ MAIN FILE
      const selectedImage = profileImages[mainIndex];

      const mainFile = selectedImage?.file || selectedImage;

      console.log("mainFile", mainFile);
      console.log("imageFiles", imageFiles);

      // =============================
      // PROFILE PHOTO
      // =============================
      if (mainFile instanceof File) {
        const profilePhotoResponse = await update_profile_photo(id, mainFile);

        console.log("profilePhotoResponse", profilePhotoResponse);
      }

      // =============================
      // MULTIPLE IMAGES
      // =============================
      if (imageFiles.length > 0) {
        const clientPhotoResponse = await update_client_photo(id, imageFiles);

        console.log("clientPhotoResponse", clientPhotoResponse);
      }

      // =============================
      // VIDEO
      // =============================
      if (videoFile instanceof File) {
        const videoResp = await update_profile_video(id, videoFile);

        console.log("videoResp", videoResp);
      }

      // =============================
      // DOCUMENT
      // =============================
      if (docFile instanceof File) {
        const doc = await update_profile_document(id, docFile, docName);

        console.log("doc upload", doc);
      }

      showToast("Upload successful!");
    } catch (error) {
      console.log("uploadPhotos error", error);
    }
  };

  const handleProfileTypeSelect = (type) => {
    console.log("Selected Profile Type:", type);

    // Example logic
    if (type === "self") {
      setSelectedRelationFrClient(self); // Himself
    } else {
      setSelectedRelationFrClient(parent); // Parent / Care Giver
    }

    setShowProfilePopup(false);
  };

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileObj = {
      uri: file,
      fileName: file.name,
    };

    // Preview the image
    setImageSource(URL.createObjectURL(file));

    // Upload the image
    selectedImage = file;
    setSelectedImage(selectedImage);
  };

  const doUpdateProfileImage = async (id, selectedFile) => {
    if (!id) {
      alert("User ID not found.");
      return;
    }

    try {
      const response = await update_profile_photo(id, selectedFile);
      console.log("Image Upload Success: ", response);
      if (response.status === 200) {
        console.log("Image Upload Success: ", response);
        // alert("Profile image uploaded successfully.");
      } else {
        alert("Profile photo upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Image Upload error: ", error);
      alert("Error uploading image.");
    }
  };

  useEffect(() => {
    // Guard runs on every step — but behaves differently depending on completion
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      const isCompleted =
        (currentStep === 3 && !!UserDataMatchPrep) || currentStep === 4;

      if (isCompleted) {
        // Profile already created — go straight to dashboard, no prompt
        navigate("/dashboard", { replace: true });

        if (UserDataMatchPrep) {
          navigate("/profileforclient", {
            replace: true,
            state: { client: UserDataMatchPrep },
          });
        }
      } else {
        // Still mid-flow — confirm before losing progress
        const confirmLeave = window.confirm(
          "Are you sure you want to go back? Your progress will be lost.",
        );

        if (confirmLeave) {
          window.history.back();
        } else {
          // Stay here — re-arm the guard for the next Back press
          window.history.pushState(null, "", window.location.href);
        }
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [currentStep, UserDataMatchPrep, navigate]);

  return (
    <div>
      {/* <div class="Business_setup">
        <img src={require("../assests/images/nav_bar_logo.png")} />
        <h2>Client Sign up | Client setup</h2>
      </div> */}

      <ClientSetupHeader currentStep={currentStep} />

      {currentStep !== 4 && (
        <ClientSetupStepper
          currentStep={currentStep}
          selectedRelationFrClient={selectedRelationFrClient}
          parent={parent}
        />
      )}

      {!UserDataMatchPrep && currentStep === 1 && (
        <div className="client_background_color">
          <div class="Client-Setup-container">
            <h2> Client overview</h2>

            <div
              style={{ cursor: "pointer" }}
              class="field"
              onClick={() => setShowProfilePopup(true)}
            >
              <label>
                Client Name | Creating Profile As a{" "}
                {selectedRelationFrClient === self ? "Self" : "Parent"}{" "}
              </label>
            </div>

            {selectedRelationFrClient === parent && (
              <div className="field">
                <select
                  value={ClientRelationId}
                  onChange={handleRelationshipId}
                >
                  <option> Creating Profile As *</option>
                  {renderRelationForClient()}
                </select>
              </div>
            )}

            <div className="field">
              <label>Select Country *</label>

              <div>
                <Select
                  options={countries}
                  placeholder="Select Country"
                  value={countries.find((c) => c.value === countryCode) || null}
                  onChange={(option) => setCountryCode(option.value)}
                  isSearchable
                  styles={customStylesbusiness}
                  isDisabled={loginby === loginByPhoneNo}
                />
              </div>
            </div>

            <div className="field">
              <label>Phone Number {loginby === loginByPhoneNo && "*"} </label>
              <input
                type="text"
                placeholder="Enter Phone Number"
                value={PhoneNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPhoneNumber(value);
                }}
                disabled={loginby === loginByPhoneNo}
              />
            </div>

            <div class="field">
              <label>Enter Your First Name *</label>
              <input
                type="text"
                placeholder="Enter Your First Name"
                value={ClientFirstName}
                onChange={(e) => setClientFirstName(e.target.value)}
              />
            </div>

            <div class="field">
              <label>Enter Your Last Name *</label>
              <input
                type="text"
                placeholder="Enter Your Last Name"
                value={ClientLastName}
                onChange={(e) => setClientLastName(e.target.value)}
              />
            </div>

            <div className="gender-container">
              <div>Select Gender *</div>
              <div className="d-flex">
                <input
                  type="radio"
                  id="male"
                  name="gender"
                  value={1}
                  checked={selectedGender === 1}
                  onChange={(e) => setSelectedGender(Number(e.target.value))}
                />
                <label htmlFor="male">Male</label>

                <input
                  type="radio"
                  id="female"
                  name="gender"
                  value={2}
                  checked={selectedGender === 2}
                  onChange={(e) => setSelectedGender(Number(e.target.value))}
                />
                <label htmlFor="female">Female</label>
              </div>
            </div>

            <div
              className="background-section__row mt-4 d-flex field"
              style={{ marginLeft: 25, marginRight: 0 }}
            >
              <label className="background-section__label" htmlFor="dob">
                Enter Date of Birth *
              </label>

              <div
                className="date-input-wrapper"
                style={{ cursor: "pointer" }}
                onClick={handleIconClick}
              >
                <ReactDatePicker
                  ref={datePickerRef}
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    setOpen(false); // close after selection
                  }}
                  onClickOutside={() => setOpen(false)}
                  open={open}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="dd-mm-yyyy"
                  className="custom-date-input"
                  maxDate={subYears(new Date(), 18)}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />

                <img
                  className="calender-icon"
                  src={require("../assests/images/calender-icon.png")}
                  alt="calendar"
                />
              </div>
            </div>

            <div className="field">
              <label>Select State *</label>

              <Select
                options={states}
                placeholder="Select State"
                value={selectedState}
                onChange={(option) => setSelectedState(option)}
                isDisabled={!countryCode}
                isSearchable
                styles={customStylesbusiness}
              />
            </div>
            <div className="field">
              <label>Select City *</label>

              <Select
                options={cities}
                placeholder="Select City"
                value={selectedCity}
                onChange={(option) => setSelectedCity(option)}
                isDisabled={!selectedState}
                isSearchable
                styles={customStylesbusiness}
              />
            </div>

            {selectedRelationFrClient === parent && (
              <div class="field">
                <label>Client description *</label>

                <textarea
                  type="text"
                  placeholder="E.g.Write a short introduction about yourself, your values, interests, and what you’re looking for in a partner"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={4}
                />
              </div>
            )}
            {selectedRelationFrClient === self && (
              <div className="field">
                <label>Relationship history *</label>
                <select
                  id="relationshipHistory"
                  onChange={handleMaritaStatusDataFromChild}
                >
                  <option value="">Select Relationship history</option>
                  {renderRelations()}
                </select>
              </div>
            )}

            {selectedRelationFrClient === self && (
              <div className="field">
                <label>
                  Enter{" "}
                  {selectedRelationFrClient === self ? "Profile" : "Client"}{" "}
                  Description *
                </label>
                <input
                  type="text"
                  value={desc}
                  placeholder="E.g.Write a short introduction about yourself, your values, interests, and what you’re looking for in a partner"
                  onChange={(e) => setDesc(e.target.value)}
                />
              </div>
            )}

            <div className="field">
              <label>Select Community *</label>

              <select
                name=""
                id=""
                className="background-section__input"
                onChange={handleCommunitiesDataFromChild}
              >
                <option value="">Select Community</option>
                {communityList?.map((comm) => (
                  <option key={comm.CommunitiesId} value={comm.CommunitiesId}>
                    {comm.CommunitiesName}
                  </option>
                ))}
              </select>
            </div>

            {selectedRelationFrClient === self && (
              <div className="profile-match-limits mt-4 ms-4">
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Religion *</label>
                    <select
                      value={selectedReligion}
                      onChange={handleReligionDataFromChild}
                    >
                      <option>Select Religion</option>
                      {renderReligion()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameReligion}
                      onChange={(e) => setLimitSameReligion(e.target.checked)}
                    />
                    Limit matches to same Religion
                  </label>
                </div> */}
                </div>

                {/* <div className="field-pair">
                  <div className="select-block">
                    <label>Select Sect(Varna)</label>
                    <select
                      required
                      value={selectedCaste}
                      onChange={handleCasteDataFromChild}
                    >
                      <option>Select Sect(Varna)</option>
                      {renderCaste()}
                    </select>
                  </div>
                  <div className="checkbox-block">
                    <label>
                      <input type="checkbox" />
                      Limit matches to same Sect(Varna)
                    </label>
                  </div>
                </div> */}
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Caste * </label>
                    <select
                      value={selectedLevel2Caste}
                      onChange={handlelevle2Caste}
                      required
                    >
                      <option>Select Caste </option>
                      {renderLevel2Caste()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameSubCaste}
                      onChange={(e) => setLimitSameSubCaste(e.target.checked)}
                    />
                    Limit matches to same Caste
                  </label>
                </div> */}
                </div>
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Sub Caste *</label>
                    <select
                      value={selectedLevel3Caste}
                      onChange={handleLevel3Caste}
                      required
                    >
                      <option>Select Sub Caste</option>
                      {renderLevel3Caste()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameSubCommunity}
                      onChange={(e) =>
                        setLimitSameSubCommunity(e.target.checked)
                      }
                    />
                    Limit matches to same Sub Caste
                  </label>
                </div> */}
                </div>

                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Language * </label>
                    <select onChange={handleSelect}>
                      <option>Select Language</option>
                      {renderLang()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitLanguage}
                      onChange={(e) => setLimitLanguage(e.target.checked)}
                    />
                    Limit matches to same language
                  </label>
                </div> */}
                  {selectedLanguage.length > 0 && (
                    <div className="selected-forwred-client">
                      {selectedLanguage?.map((lang) => (
                        <span key={lang.LangId} className="tag">
                          {lang.LangDesc}
                          <button
                            className="click-effect"
                            onClick={() => removeLanguage(lang)}
                          >
                            X
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div class="Client-container">
            <h2>Background Information</h2>

            <div className="field-pair">
              <div className="select-block">
                <label>Enter Address Details *</label>
                <input
                  value={addresDet}
                  placeholder="Enter Address Details"
                  onChange={handelAddreesDet}
                />
              </div>
            </div>

            <div className="field-pair mt-3">
              <div className="select-block">
                <label>Select Residence</label>
                <select
                  className="background-section__input"
                  value={selectedResidence}
                  onChange={handleResidence}
                >
                  <option value="">Select Residence</option>
                  {countryList?.map((contry) => (
                    <option key={contry.id} value={contry.id}>
                      {contry.CountryName} ( {contry.CountryCode} )
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="field-pair mt-3">
              <div className="select-block">
                <label>Select Citizenship</label>
                <select
                  className="background-section__input"
                  value={selectedCitizenship}
                  onChange={handleCitizenship}
                >
                  <option value="">Select Citizenship</option>
                  {countryList?.map((contry) => (
                    <option key={contry.id} value={contry.id}>
                      {contry.CountryName} ( {contry.CountryCode} )
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="field-pair mt-3">
              <div className="select-block">
                <label>Select Ethinicity</label>
                <select
                  className="background-section__input"
                  value={seletedEthinicity}
                  onChange={handleEthinicity}
                >
                  <option value="">Select Ethinicity</option>
                  {communityList?.map((city) => (
                    <option key={city.CommunitiesId} value={city.CommunitiesId}>
                      {city.CommunitiesName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="field-pair mt-3">
              <div className="select-block">
                <label> Enter Postal Code</label>
                <input
                  type="text"
                  value={postalcode}
                  onChange={handlePostalcode}
                  className="background-section__input"
                  placeholder=" Enter Postal Code"
                />
              </div>
            </div>
          </div>

          {selectedRelationFrClient === self && (
            <div style={{ marginLeft: "3%" }} className="me-4">
              <AddFamilyMemeberForClient
                familyDetails={familyDetails}
                setFamilyDetails={setFamilyDetails}
              />

              <AddFamilyWealthForClient
                familyWealth={familyWealth}
                setFamilyWealth={setFamilyWealth}
              />

              <EducationWorkForm
                qualifications={qualifications}
                handleQualificationDataFromChild={
                  handleQualificationDataFromChild
                }
                selectedQualification={selectedQualification}
                collageName={collageName}
                setCollageName={setCollageName}
                jobRole={jobRole}
                setJobRole={setJobRole}
                Salary={Salary}
                setSalary={setSalary}
                carrerGoals={carrerGoals}
                setcarrerGoals={setcarrerGoals}
                salaryCurrency={salaryCurrency}
                setSalaryCurrency={setSalaryCurrency}
                allCountyMasterData={allCountyMasterData}
              />
              <PhysicalAttributesForm
                height={height}
                setHeight={setHeight}
                weight={weight}
                setWeight={setWeight}
                skinToneList={skinToneList}
                selectedSkinTone={selectedSkinTone}
                handelDataFromSkinToneModal={handelDataFromSkinToneModal}
                physicalbuildList={physicalbuildList}
                selectedBuild={selectedBuild}
                handelDataFromBuildModal={handelDataFromBuildModal}
              />

              <PhotographUploader
                profileImages={profileImages}
                setProfileImages={setProfileImages}
                accessOnRequest={accessOnRequest}
                setAccessOnRequest={setAccessOnRequest}
                mainIndex={mainIndex}
                setMainIndex={setMainIndex}
              />

              <LifestyleAndInterests
                habitList={habitList}
                selectedHabit={selectedHabit}
                setSelectedHabit={setSelectedHabit}
                hobbiesList={hobbiesList}
                selectedHobbies={selectedHobbies}
                setSelectedHobbie={setSelectedHobbie}
              />

              <VideoAndDocumentsUploader
                videoFile={videoFile}
                setVideoFile={setVideoFile}
                communitieDocs={communitieDocs}
                docFile={docFile}
                setDocFile={setDocFile}
                docName={docName}
                setDocName={setDocName}
                selectedReligion={selectedReligion}
              />
            </div>
          )}
          {selectedRelationFrClient === parent && (
            <div className="profile-image">
              <h2>Profile photo</h2>
              <p>optional</p>
              <div className="Business_symbol">
                <label htmlFor="imageUpload" className="upload-label">
                  <img
                    src={imageSource}
                    alt="Profile Preview"
                    className="preview-image"
                  />

                  <div className="plus-icon-for-agent">
                    <span style={{ color: "#B35381", fontSize: 30 }}> +</span>
                  </div>
                </label>

                <input
                  id="imageUpload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageSelection}
                  className="hidden-input"
                />
              </div>
            </div>
          )}

          {/* {showProfilePopup && (
            <CreateProfilePopup onSelect={handleProfileTypeSelect} />
          )} */}

          {/* <div class="footer-reg">
            <div onClick={CreateClient}>
              {btnLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </>
              ) : (
                <h3>Finish Registration ›</h3>
              )}
            </div>
          </div> */}

          <div class="footer-reg">
            <div
              onClick={async () => {
                if (btnLoading) {
                  return;
                }

                setBtnLoading(true);

                try {
                  if (!(await ValidateProfile())) {
                    return;
                  }

                  if (
                    selectedRelationFrClient === self &&
                    !validateAdressAndSalary()
                  ) {
                    return;
                  }

                  // GO TO PAYMENT
                  setCurrentStep(2);
                } finally {
                  setBtnLoading(false);
                }
              }}
            >
              {btnLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </>
              ) : (
                <h3>Continue ›</h3>
              )}
            </div>
          </div>

          <div className="business_footer_line"></div>
        </div>
      )}

      {currentStep === 2 && (
        <div>
          <ClientPayment btnLoading={btnLoading} CreateClient={CreateClient} />
          <div class="footer-reg" onClick={() => setCurrentStep(1)}>
            <div>
              <h3> {"<"} Back</h3>
            </div>
          </div>
        </div>
      )}

      {currentStep === 3 && UserDataMatchPrep && (
        <div className="Business_background_color pt-4">
          <ClientPreferences UserData={UserDataMatchPrep} />

          <div
            class="footer-reg"
            // onClick={() => navigate("/dashboard", { replace: true })}

            onClick={() =>
              navigate("/profileforclient", {
                replace: true,
                state: { client: UserDataMatchPrep },
              })
            }
          >
            <div>
              <h3>Go to Dashboard ›</h3>
            </div>
          </div>
        </div>
      )}

      {currentStep === 4 && (
        <div className="client-success-wrapper">
          <div className="client-success-card">
            <img
              src={require("../../src/assests/images/payment_icon.png")}
              alt="success"
              className="success-icon"
            />

            <h3>Successfully Joined Partner Suite!</h3>

            <p>
              Valid till:{" "}
              {new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </p>

            <button
              className="proceed-home-btn"
              onClick={() => navigate("/dashboard")}
            >
              Proceed to Home ›
            </button>
          </div>
        </div>
      )}

      <div id="toast-message"></div>
    </div>
  );
}

export default Client_set_up;
